<template>

  <b-col>
    <h1 v-if="!loading">
      <span v-if="phone">Телефон {{ formatPhone(phone.phone) }}</span>
      <span v-else>Новый телефон</span>
    </h1>
    <b-row>
      <b-col>
        <b-overlay :show="loading">
          <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">

            <b-form-group
              id="phone-group"
              label="Номер телефона:"
              label-for="phone"
              description="Номер телефона будет использоваться для привязки к истории звонков."
            >
              <b-form-input
                id="phone"
                v-model="form.phone"
                type="text"
                required
                placeholder="79001002030"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              id="name-group"
              label="Название:"
              label-for="name"
              description="Будет отображаться в статистике."
            >
              <b-form-input
                id="name"
                v-model="form.name"
                type="text"
                placeholder="Название телефона"
              ></b-form-input>
            </b-form-group>

            <b-form-checkbox
              id="tracking-enabled"
              v-model="form.tracking_enabled"
            >
              Используется для колл-трекинга
            </b-form-checkbox>

            <div v-if="form.tracking_enabled">
              <b-form-checkbox
                id="tracking-default"
                v-model="form.tracking_default"
              >
                Номер по-умолчанию для колл-трекинга. Будет выводиться, если другие номера не подошли.
              </b-form-checkbox>

              <b-form-checkbox
                id="enable-rules"
                v-model="form.rules_disabled"
              >
                Выключить правила. Телефон будет использоваться в статистике, но не применяться в подборе.
              </b-form-checkbox>

              <div v-if="!form.rules_disabled">
                <h4 class="mt-2">Правила</h4>

                <div v-if="form.tracking_params">
                <b-card 
                  bg-variant="light"
                  class="mt-2"
                  :key="'rule-' + index"
                  v-for="(rule, index) in form.tracking_params.rules"
                >

                  <b-form-group
                    id="url-group"
                    label="URL страницы:"
                    label-for="url"
                    description="URL страницы или его часть."
                  >
                    <b-form-input
                      id="url"
                      v-model="form.tracking_params.rules[index].url"
                      type="text"
                      placeholder="/page1/"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    id="referer-group"
                    label="Referer:"
                    label-for="referer"
                    description="URL или часть URL страницы, откуда был произведён переход. Например, для ссылки https://www.example.tld/page/ подойдёт как www.example.tld/page, так и просто /page"
                  >
                    <b-form-input
                      id="referer"
                      v-model="form.tracking_params.rules[index].referer"
                      type="text"
                      placeholder="www.yandex.ru/search"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    id="query-group"
                    label="Строка запроса:"
                    label-for="query"
                    description="Строка запроса - часть после символа '?' в ссылке. Лучше всего подходит для utm-меток, так как игнорирует порядок частей этой строки. Например, значение utm1=var1&utm2=var2 сработает как для ?utm1=var1&utm2=var2, так и для ?utm2=var2&utm1=var1 "
                  >
                    <b-form-input
                      id="referer"
                      v-model="form.rules_list[index]"
                      type="text"
                      placeholder="www.yandex.ru/search"
                    ></b-form-input>
                  </b-form-group>
                  <p v-for="(v, k) in makeQuery(form.rules_list[index])" :key="k">
                    {{ k }} = {{ v }}
                  </p>

                  <template v-slot:footer>
                    <b-button variant="danger" size="sm" @click="removeRule(index)">
                      <fa-icon icon="times-circle"/> Удалить
                    </b-button>
                  </template>
                </b-card>
                </div>
                <b-button variant="primary" size="sm" class="mt-2" @click="addRule">
                  <fa-icon icon="plus"/>Добавить правило
                </b-button>
              </div>
            </div>
            <hr />
            <b-button-group>
              <b-button type="submit" variant="primary">
                <fa-icon icon="save"/> Сохранить
              </b-button>
            </b-button-group>
          </b-form>

        </b-overlay>
      </b-col>
    </b-row>
  </b-col>

</template>

<script>
import qs from 'qs';

import { store } from "@/store";
import Api from "@/lib/Api";
import Utils from "@/lib/Utils";


export default {
    name: 'PhoneEdit',
    props: [
        'projectId',
        'phoneId',
    ],
    data () {
        return {
            loading: false,
            phone: null,
            form: {},
            appState: store.state
        };
    },
    created () {
        this.loadData();
    },
    watch: {
        '$route': 'loadData'
    },
    methods: {
        async loadData () {
            if (!this.phoneId) {
                return;
            }
            this.loading = true;
            try {
                const phone = await Api.getPhone(
                    parseInt(this.projectId),
                    parseInt(this.phoneId)
                );
                this.phone = phone;
            } catch (e) {
                console.error(e);
                this.$bvToast.toast('Ошибка загрузки телефона', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true,
                    noAutoHide: true
                });
            }
            this.loading = false;
            this.form = this.initForm();
        },
        initForm () {
            var form = {};
            if (this.phone) {
                form = JSON.parse(JSON.stringify(this.phone));
                delete form.id;
                form.rules_list = [];
                if (form.tracking_params && form.tracking_params.rules) {
                    form.rules_list = form.tracking_params.rules.map(rule => {
                        return qs.stringify(rule.query);
                    });
                }
            }
            return form;
        },
        makeQuery (string) {
            return qs.parse(string);
        },
        addRule () {
            if (!this.form.tracking_params) {
                this.form.tracking_params = {};
            }
            if (!this.form.tracking_params.rules) {
                this.form.tracking_params.rules = [];
            }
            this.form.tracking_params.rules.push({});
            this.form.rules_list.push('');
        },
        removeRule (index) {
            this.form.tracking_params.rules.splice(index, 1);
            this.form.rules_list.splice(index, 1);
        },
        async onSubmit () {
            /* Process tracking params */
            const data = JSON.parse(JSON.stringify(this.form));
            if (!data.tracking_params) {
                data.tracking_params = {};
            }
            if (data.rules_list) {
                data.rules_list.forEach((rule, i) => {
                    data.tracking_params.rules[i].query = qs.parse(rule);
                });
            }
            delete data.rules_list;
            delete data.active;
            delete data.date_created;
            delete data.date_updated;
            delete data.project_id;
            if (data.rules_disabled) {
                data.tracking_params.match = false;
            }
            delete data.rules_disabled;

            /* Send data */
            var phone = null;
            this.loading = true;
            console.log(data);
            try {
                if (this.phoneId) {
                    phone = await Api.updatePhone(
                        parseInt(this.projectId),
                        parseInt(this.phoneId),
                        data
                    );
                } else {
                    phone = await Api.createPhone(
                        parseInt(this.projectId),
                        data
                    );
                    if (phone.id) {
                        this.$router.push({name: 'phone-edit',
                                           params: {projectId: this.projectId,
                                                    phoneId: phone.id}});
                    }
                }
                this.phone = phone;
                this.$root.$bvToast.toast('Телефон успешно сохранён', {
                    title: 'Выполнено',
                    variant: 'success',
                    solid: true,
                });
            } catch (e) {
                console.error(e);
                this.$bvToast.toast('Ошибка сохранения телефона', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true,
                    noAutoHide: true
                });
            }
            this.loading = false;
            this.form = this.initForm();

        },
        ...Utils
    },
};

</script>
